import { render } from "./Navigation.vue?vue&type=template&id=8b70cd0e&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=8b70cd0e&lang=scss&scoped=true"
import "./Navigation.vue?vue&type=style&index=1&id=8b70cd0e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b70cd0e"]])

export default __exports__